'use client'

import { ExternalLink, Toast } from 'modules/components'
import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { HeaderLogo, HeaderMenus, SocialGroup } from 'modules/constant'
import {
  TrackClick,
  TrackerProvider,
  TrackExposure,
  TrackNavbarSection,
  TrackPageSection,
  TrackPageType,
  TrackRoute,
} from 'modules/analysis'

function LayoutHeader() {
  const pathname = usePathname()

  const [isIntersecting, setIsIntersecting] = useState(true)
  useEffect(() => {
    const targetElement = document.querySelector('#bgIntersectionObserver')

    if (targetElement) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsIntersecting(entry.isIntersecting)
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        },
      )
      observer.observe(targetElement)
      return () => {
        observer.disconnect()
      }
    } else {
      setIsIntersecting(false)
    }
  }, [pathname])

  return (
    <div
      className={clsx(
        {
          'bg-black-bg': !isIntersecting,
        },
        'sticky top-0 z-50 h-[10em] w-full shrink-0 text-base transition-colors duration-300 ease-in-out',
      )}
    >
      <TrackerProvider config={{ pageType: TrackPageType.Navbar }}>
        <TrackExposure config={{ sectionName: TrackPageSection }}>
          <div className="section-content flex-x-center h-full justify-between">
            <TrackRoute config={{ sectionName: TrackNavbarSection.Logo }}>
              <Link href="/" className="shrink-0 pb-2">
                <span className="pb-2">{HeaderLogo}</span>
              </Link>
            </TrackRoute>
            <div>
              <div className="flex-x-center gap-x-[4em] pt-2">
                {HeaderMenus.map(({ path, content, tracker }) => (
                  <TrackRoute config={{ sectionName: tracker }} key={path}>
                    <Link
                      className={clsx('hover:text-primary-hover text-[16px] font-bold tracking-wider', {
                        'text-primary': path === pathname,
                      })}
                      href={path}
                      key={path}
                    >
                      {content}
                    </Link>
                  </TrackRoute>
                ))}
              </div>
            </div>

            <div className="flex-x-center pt-1">
              <div className="mr-13 flex gap-x-[1em] text-base">
                {SocialGroup.map(({ content, path, tracker }) => (
                  <TrackClick
                    config={{ sectionName: TrackNavbarSection.Media, attr: { iconType: tracker } }}
                    key={path}
                  >
                    <ExternalLink href={path} className="link" key={path}>
                      {content}
                    </ExternalLink>
                  </TrackClick>
                ))}
              </div>
              <TrackRoute config={{ sectionName: TrackNavbarSection.Subscribe }}>
                <Link href="/news/#join-newsletter">
                  <button className="primary-button font-bold uppercase">Subscribe</button>
                </Link>
              </TrackRoute>
            </div>
          </div>
        </TrackExposure>
      </TrackerProvider>

      <Toast transform={50} className="h-[60px] text-xl font-medium" />
    </div>
  )
}

export default LayoutHeader
